import { useMutation, useQueryClient } from '@tanstack/react-query';
import { duplicateStudy } from '@/features/studies/domain/studies.api';
import { useNotification, useNavigation } from '@refinedev/core';
import { useTranslation } from 'react-i18next';
import { StudyDetail } from '@aphp-ema/common/study';
import { auditLogsQueryKeys } from '@/features/audit-logs/api/queryKeys';

export const useDuplicateStudy = () => {
  const { open: openNotification } = useNotification();
  const { edit } = useNavigation();
  const { t } = useTranslation();
  const queryClient = useQueryClient();

  const { mutate, isLoading } = useMutation({
    mutationFn: duplicateStudy,
    onSuccess: (newStudy: StudyDetail) => {
      openNotification?.({
        type: 'success',
        message: t('notifications.studyDuplicated'),
        description: t('notifications.studyDuplicatedDescription', {
          name: newStudy.name,
        }),
      });

      queryClient.invalidateQueries(['admin/studies']);
      queryClient.invalidateQueries(auditLogsQueryKeys.all);

      edit('admin/studies', newStudy.id);
    },
    onError: (error: Error) => {
      openNotification?.({
        type: 'error',
        message: t('notifications.errorDuplicatingStudy'),
        description: error.message,
      });
    },
  });

  return { duplicateStudy: mutate, isLoading };
};
